import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const useDeleteNotification = () =>
  useMutation({
    mutationFn: async (id: string) => {
      const res = await apiClient.delete(ENDPOINTS.ANNOUNCEMENTS.DELETE_ANNOUNCEMENT(id));
      return res.data;
    },
  });